import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class NotificationsService {
  freeTimesEtag = null;
  absencesTodayEtag = null;

  validadeTokenExist(bodyParms) {
    return axios
      .post(`${config["apiUrl"]}notifications/tokenExist`, bodyParms,  {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getNotificationConfig() {
    return axios
      .get(`${config["apiUrl"]}notifications/config`, { headers: authHeader() })
      .then(response => {
        if (response.status == 200) {
          return response.data;
        }
      })
      .catch(error => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getFreeTimes(force = false) {
    const headers = authHeader();
    if (!force && this.freeTimesEtag) {
      headers["If-None-Match"] = this.freeTimesEtag;
    }

    return axios
      .get(`${config["apiUrl"]}notifications/freeTimes`, {
        headers,
        params: force ? { force: true } : undefined,
        validateStatus: status => (status >= 200 && status < 300) || status === 304,
      })
      .then(response => {
        if (response.status === 304) {
          return { notModified: true };
        }
        if (response.status == 200) {
          const etagHeader = response.headers && (response.headers.etag || response.headers.ETag);
          if (etagHeader) {
            this.freeTimesEtag = etagHeader;
          }
          return response.data;
        }
      })
      .catch(error => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  freeTimesRead(id) {
    return axios
      .patch(`${config["apiUrl"]}notifications/freeTimes/${id}/read`, {}, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          this.freeTimesEtag = null;
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getAbsencesToday() {
    const headers = authHeader();
    if (this.absencesTodayEtag) {
      headers["If-None-Match"] = this.absencesTodayEtag;
    }

    return axios
      .get(`${config["apiUrl"]}notifications/absencesToday`, {
        headers,
        validateStatus: status => (status >= 200 && status < 300) || status === 304,
      })
      .then(response => {
        if (response.status === 304) {
          return { notModified: true };
        }
        if (response.status == 200) {
          const etagHeader = response.headers && (response.headers.etag || response.headers.ETag);
          if (etagHeader) {
            this.absencesTodayEtag = etagHeader;
          }
          return response.data;
        }
      })
      .catch(error => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  absencesTodayRead(id) {
    return axios
      .patch(`${config["apiUrl"]}notifications/absencesToday/${id}/read`, {}, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          this.absencesTodayEtag = null;
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getTicketNotifications() {
    return axios
      .get(`${config["apiUrl"]}notifications/ticketNotifications`, { headers: authHeader() })
      .then((response) => {
        if (response.status === 200) return response.data;
        return [];
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return [];
      });
  }

  markTicketNotificationRead(id) {
    return axios
      .patch(`${config["apiUrl"]}notifications/ticketNotifications/${id}/read`, {}, { headers: authHeader() })
      .then((response) => (response.status === 200 ? response.data : null))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return null;
      });
  }

  getBirthdaysToday() {
    return axios
      .get(`${config["apiUrl"]}notifications/birthdaysToday`, { headers: authHeader() })
      .then((response) => (response.status === 200 ? response.data.names : []))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return [];
      });
  }

  getVacationsReminders() {
    return axios
      .get(`${config["apiUrl"]}notifications/vacationsReminders`, { headers: authHeader() })
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return null;
      });
  }

  markVacationsReminderRead(id) {
    return axios
      .patch(`${config["apiUrl"]}notifications/vacationsReminders/${id}/read`, {}, { headers: authHeader() })
      .then((response) => (response.status === 200 ? response.data : null))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return null;
      });
  }

  sendVacationsReminder(userId, reminderType, overridePayload) {
    return axios
      .post(
        `${config["apiUrl"]}notifications/vacationsReminders/user/${userId}/send`,
        { reminder_type: reminderType, ...(overridePayload || {}) },
        { headers: authHeader() }
      )
      .then((response) => (response.status === 200 ? response.data : null))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return null;
      });
  }
}
export default new NotificationsService();
